import isMobile from "ismobilejs";

// ismobilejs v1 default-exports a factory instead of a pre-evaluated result.
// Invoke it once here so consumers keep the object API (`isMobile.any`,
// `isMobile.apple.device`, ...) that v0.5 handed back from the module itself.
export default isMobile();
